import "./Footer.scss";
import HeaderLogo from "../../assets/images/header-logo.svg";

import { ReactComponent as XLogo } from "../../assets/icons/XLogo.svg";
import { ReactComponent as TelegramIcon } from "../../assets/icons/Telegram.svg";
import { ReactComponent as DextoolsIcon } from "../../assets/icons/DexTools.svg";
import { ReactComponent as GithubIcon } from "../../assets/icons/Github.svg";
import { ReactComponent as GitbookIcon } from "../../assets/icons/Gitbook.svg";
import { ReactComponent as DexscreenerIcon } from "../../assets/icons/Dexscreener.svg";

import EsphereLeftImg from "../../assets/images/footer/esphere-left.png";
import EsphereRightImg from "../../assets/images/footer/esphere-right.png";
import EsphereCenterImg from "../../assets/images/hero/esphere-center.png";

export default function Footer() {
	return (
		<div className="footer" id="footer">
			<div className="footer-content-wrap content-wrapper-lg">
				{/* decorations */}
				<img
					src={EsphereLeftImg}
					alt="esphere-left"
					className="esphere-left decoration"
				/>
				<img
					src={EsphereRightImg}
					alt="esphere-right"
					className="esphere-right decoration"
				/>
				<img
					src={EsphereCenterImg}
					alt="esphere-center"
					className="esphere-center decoration"
				/>

				<div className="footer-content">
					<div className="footer-left">
						<img
							className="footer-logo"
							src={HeaderLogo}
							alt="Footer Logo"
							width="60"
							height="37"
						/>
					</div>

					<div className="footer-right">
						<ul className="footer-socials">
							<li className="footer-socials-item">
								<a
									href="#-"
									target="_blank"
									rel="noreferrer"
									className="footer-socials-link"
								>
									<XLogo className="footer-socials-icon" />
								</a>
							</li>
							<li className="footer-socials-item">
								<a
									href="#-"
									target="_blank"
									rel="noreferrer"
									className="footer-socials-link"
								>
									<TelegramIcon className="footer-socials-icon" />
								</a>
							</li>
							<li className="footer-socials-item">
								<a
									href="#-"
									target="_blank"
									rel="noreferrer"
									className="footer-socials-link"
								>
									<DextoolsIcon className="footer-socials-icon" />
								</a>
							</li>
							{/* <li className="footer-socials-item">
								<a
									href="#-"
									target="_blank"
									rel="noreferrer"
									className="footer-socials-link"
								>
									<GithubIcon className="footer-socials-icon" />
								</a>
							</li> */}
							<li className="footer-socials-item">
								<a
									href="#-"
									target="_blank"
									rel="noreferrer"
									className="footer-socials-link"
								>
									<GitbookIcon className="footer-socials-icon" />
								</a>
							</li>
							<li className="footer-socials-item">
								<a
									href="#-"
									target="_blank"
									rel="noreferrer"
									className="footer-socials-link"
								>
									<DexscreenerIcon className="footer-socials-icon" />
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div className="footer-copyright">
					<p>Copyright © 2025 Vernus-AI®. All rights reserved.</p>
				</div>
			</div>
		</div>
	);
}
